import { h } from 'preact';

export default props => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M3.5 7H11C12.38 7 13.5 8.12 13.5 9.5C13.5 10.88 12.38 12 11 12H7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M5.5 5L3.5 7L5.5 9" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
